import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import MenuArrow from './MenuArrow';
import appConfig from '../../../../app-config';

const NotAuthDiv = styled.div`
  position: relative;
  margin-top: 24px;
  margin-bottom: 48px;

  display: grid;
  grid-template-columns: auto 1fr;
`;

const NotAuthText = styled.div`
  color: ${props => props.theme.notAuthTextColour};
  font-family: ${props => props.theme.primaryFontFontFamily};
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02px;
  margin-top: 13px;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;

const NotAuthRewards = ({setAuthenticationModalIsVisible}) => {
  return (
    <NotAuthDiv>
      <div>
        <MenuArrow />
        <NotAuthText onClick={() => setAuthenticationModalIsVisible(true)}>
          {appConfig.appSource === 'iQ' ? (
            <div>
              <p>Sign in for rewards and other goodness</p>
            </div>
          ) : (
            <div>
              <p>Sign In to Receive Rewards </p>
              <p>and View Exclusive Offers</p>
            </div>
          )}
        </NotAuthText>
      </div>
    </NotAuthDiv>
  );
};

export default NotAuthRewards;
